// extracted by mini-css-extract-plugin
export default {"fileItem":"UploadedFile_fileItem__CYSvZ","fileIcon":"UploadedFile_fileIcon__anlUa","fileName":"UploadedFile_fileName__yC232"};